import { render, staticRenderFns } from "./ZeropointDetails.vue?vue&type=template&id=b6bdd414&scoped=true&"
import script from "./ZeropointDetails.vue?vue&type=script&lang=js&"
export * from "./ZeropointDetails.vue?vue&type=script&lang=js&"
import style0 from "./ZeropointDetails.vue?vue&type=style&index=0&id=b6bdd414&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6bdd414",
  null
  
)

export default component.exports